import { Injectable, inject } from '@angular/core'
import { RestClient } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ShopfloorLayoutContext } from './shopfloor-layout-context'

@Injectable({
  providedIn: 'root',
})
export class ShopfloorLayoutContextService extends RestClient<ShopfloorLayoutContext, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)
    super(environment.apiPath + '/shopfloor/layout-context', http, {
      idField: 'facility',
    })
  }
}
